import { Alert, Button, CircularProgress, TextField } from '@mui/material';
import React from 'react';

function PasswordFormUI({
  demoEmail,
  handleSubmit,
  loading,
  error,
  password,
  setPassword,
}: {
  demoEmail: string;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  loading: boolean;
  error: string;
  password: string;
  setPassword: (password: string) => void;
}) {
  return (
    <form onSubmit={handleSubmit}>
      <TextField
        fullWidth
        label="Email"
        value={demoEmail}
        disabled
        variant="outlined"
        margin="normal"
        sx={{ marginBottom: 2 }}
      />

      <TextField
        fullWidth
        label="Password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        variant="outlined"
        margin="normal"
        autoFocus
        disabled={loading}
        sx={{ marginBottom: 2 }}
      />

      {error && (
        <Alert severity="error" sx={{ marginBottom: 2 }}>
          {error}
        </Alert>
      )}

      <Button
        type="submit"
        fullWidth
        variant="contained"
        disabled={loading || !password.trim()}
        sx={{
          marginTop: 2,
          marginBottom: 2,
          height: 48,
        }}
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : 'Sign In'}
      </Button>
    </form>
  );
}

export default PasswordFormUI;
